const FilterLayout = ({ children }) => {
  return <div className="filter-toolbar mt-3">{children}</div>;
};

const FilterToolbarItem = ({ children }) => {
  return <div className="filter-toolbar-item">{children}</div>;
};

export { FilterLayout, FilterToolbarItem };
